import { TimeField } from '@components/form/TimeField/TimeField';
import { Field } from 'formik';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

export const FormikTimeField = memo(function FormikTimeField({
    name,
    ...props
}: { name: string } & Omit<React.ComponentProps<typeof TimeField>, 'onChange' | 'value'>) {
    return (
        <Field name={name}>
            {({ field: { value, onBlur }, form: { setFieldValue }, meta: { error, touched } }) => (
                <TimeField
                    {...props}
                    name={name}
                    value={value}
                    error={touched && !!error}
                    helperText={touched && typeof error === 'string' && <FormattedMessage id={error} defaultMessage={error} />}
                    onBlur={onBlur}
                    onChange={date => {
                        setFieldValue(name, typeof date === 'number' ? date : date.getTime());
                    }}
                />
            )}
        </Field>
    );
});
